import { render, staticRenderFns } from "./DoctorsList.vue?vue&type=template&id=ee3382e8&scoped=true"
import script from "./DoctorsList.vue?vue&type=script&lang=js"
export * from "./DoctorsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3382e8",
  null
  
)

export default component.exports